function r(u,n,t){return(1-t)*u+t*n}export{r as default};
//# sourceMappingURL=lerp.js.map
